import {
    DonationRhythm,
    DonationType,
    SponsorshipType
} from "../../components/forms/F007ModularDonationForm/types";

export function rhythmToString(val: any | undefined): string | undefined {
    if (val === undefined || val === null) return undefined;
    switch (val) {
        case DonationRhythm.Monthly:
            return "Monthly";
        case DonationRhythm.Unique:
            return "Unique";
        default:
            return String(val);
    }
}

export function typeToString(val: DonationType | null | undefined): string | undefined {
    switch (val) {
        case DonationType.Donation:
            return "Donation";
        case DonationType.Sponsorship:
            return "Sponsorship";
        case DonationType.Product:
            return "Product";
        default:
            return val != null ? String(val) : undefined;
    }
}

export function sponsorshipTypeToString(val: any | undefined): string | undefined {
    if (val === undefined || val === null) return undefined;
    switch (val) {
        case SponsorshipType.ChildSponsorship:
            return "Child";
        case SponsorshipType.VillageSponsorshipInGermany:
            return "Village_Germany";
        case SponsorshipType.VillageSponsorshipAbroad:
            return "Village_Abroad";
        default:
            return String(val);
    }
}
